<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    fullscreen
>
    <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>Edit Location</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="onClickDiscard"
            >
              Cancel
            </v-btn>

            <v-btn
              dark
              text
              @click="onClickSave"
              :disabled="!is_valid"
            >
              Save &amp; Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            v-if="location != null"
        >
            <v-form
                v-model="is_valid"
            >
                <v-text-field
                    label="Location Id"
                    disabled
                    v-model="location.location_id"
                    autocomplete="off"
                />

                <v-text-field
                    label="Internal Label"
                    v-model="location.internal_label"
                    hint="Only visible to RedChirp Users"
                    autocomplete="off"
                    :rules="[rules.required]"
                />

                <v-text-field
                    label="Label"
                    v-model="location.label"
                    hint="Visible to customers"
                    autocomplete="off"
                    :rules="[rules.required]"
                />

                <m-select-timezone
                    v-model="location.timezone"
                />

                <b>Address:</b>

                <m-address-editor
                    v-model="location.address"
                />

                <b>Hours:</b>

                <m-daily-schedule
                    v-model="location.open_hours"
                    :read_only="false"
                />

            </v-form>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            location: null,
            is_valid: false,

            rules: {
                required: (value) => { if ( value == null || value.trim().length == 0 ) return 'Required'; return true;  },
            },
        }
    },

    methods: {

        showDialog(location)
        {
            this.inboxes = [];
            this.location = _.cloneDeep(location);

            this.$rc.showSpinner();
            
            this.$rc.getOrganizationProfile(
                location.organization_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.dialog = true;
                    this.$router.dialog_guard = this.dialogGuard;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get inboxes');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            // The dialog is showing...
            if ( this.is_valid )
            {
                // The location is valid, so save and close the dialog (but don't proceed to the new route...)
                this.saveLocation();
                this.dialog = false;
                next(false);
                return;
            }

            this.$rc.snackbar('You must either correct the errors in this location or discard your changes.',3500);
            this.dialog = true;
            next(false);
        },

        showDialogNewLocation(organization_id)
        {
            this.$rc.showSpinner();
            
            this.$rc.getDefaultNewLocationForOrganization(
                organization_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.showDialog(data.location);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create new location');
                },
            );
        },

        onClickSave()
        {
            this.closeDialog();
            this.saveLocation();
        },

        saveLocation()
        {
            this.$rc.showSpinner();
            
            this.$rc.upsertLocation(
                this.location,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Location saved',3500);

                    this.$emit('ok');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to save location');
                },
            );
        },

        onClickDiscard()
        {
            this.closeDialog();
        },

    },
}
</script>

<style lang="scss" scoped>
</style>